module.exports = "./images/logo-greatcontent.png";